import React from 'react';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { Discussion } from './Discussion';
const client = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
        },
    },
});
export const DiscussionRoot = ({ id, endpoint, depth = 2, }) => {
    return (React.createElement(QueryClientProvider, { client: client },
        React.createElement(Discussion, { id: id, endpoint: endpoint, depth: depth })));
};
//# sourceMappingURL=DiscussionRoot.js.map